import React from 'react'
import { Route, Routes } from 'react-router-dom'

// screens
import Contact from './views/Contact'
import About from './views/About'
import Login from './views/Login'
import New from './views/CreatePost'
import Post from './views/Post'
import Posts from './views/Posts'
import UserProfile from './views/UserProfile'
import QuickPost from './views/QuickPost'
import ProfileNew from './views/ProfileNew'
import Privacy from './views/Privacy'
import Terms from './views/Terms'
import Bounce from './views/Bounce'

// components
import Header from './components/Header'
import Footer from './components/Footer'
import Loading from './components/Loading'

// auth
import { AuthProvider, AuthConsumer } from './auth/AuthContext'

const App = () => {
  return (
    <AuthProvider>
      <AuthConsumer>
        {({ anonymous, user, userName, userLoading, refreshProfile }) => (
          (!userLoading)
            ? (
              <>
                <Header />
                <Routes>
                  {(user && !anonymous) && !userName && <Route path='/' element={<ProfileNew />} />}
                  <Route path='/' element={<Posts />} />
                  <Route path='/contact' element={<Contact />} />
                  <Route path='/about' element={<About />} />
                  <Route path='/postulation/:postulationId' element={<Post />} />
                  {(user || anonymous) && <Route path='/quick-post/:postulationId' element={<QuickPost />} />}
                  <Route path='/privacy' element={<Privacy />} />
                  <Route path='/terms' element={<Terms />} />
                  {user && !anonymous && <Route path='/profile/*' element={<UserProfile />} />}
                  {user && !anonymous && <Route path='/add/:sourceId' element={<New />} />}
                  {user && !anonymous && <Route path='/add' element={<New />} />}
                  {user && <Route path='/bounce' element={<Bounce />} />}
                  <Route path='/login' element={<Login />} />
                </Routes>
                <Footer />
              </>
              )
            : <Loading />
        )}
      </AuthConsumer>
    </AuthProvider>
  )
}

export default App
